import React, { forwardRef } from 'react'

import { Box, BoxProps } from '../Box'
import { useBadgeStyle } from '../../hooks/useBadgeStyle'

export interface BadgeProps extends BoxProps {
  variantColor?: string
  variant?: 'solid' | 'outline' | 'subtle'
  isRound?: boolean
}

export const Badge = forwardRef(
  ({ variantColor = 'gray', variant = 'subtle', isRound, ...props }: BadgeProps, ref) => {
    const badgeStyleProps = useBadgeStyle({ color: variantColor, variant, isRound })

    return (
      <Box
        ref={ref}
        display="inline-flex"
        justifyContent="center"
        alignItems="center"
        px={1}
        textTransform="uppercase"
        fontFamily="heading"
        fontSize="sm"
        borderRadius="sm"
        fontWeight="bold"
        whiteSpace="nowrap"
        verticalAlign="middle"
        textAlign="center"
        {...badgeStyleProps}
        {...props}
      />
    )
  },
)

Badge.displayName = 'Badge'

export default Badge
